import { TileIds, TileRules } from '../../../../util/tileEnums';
import { AetnaModalValue } from '../../../components/InsuranceHelpModal/modalValues';
import { InsurerCodes } from '../../../../../../../constants/insurance';

export const aetnaInsightTiles = [
  {
    id: TileIds.INSURANCE_INSIGHT_NURSE_HOTLINE,
    header: 'Call Anytime',
    description: () => `24/7 access to a nurse hotline`,
    rules: [TileRules.IS_INSURANCE_AETNA, TileRules.IS_NOT_CHILD],
    modalValue: AetnaModalValue.NURSE_HOTLINE,
    sortOrder: { [InsurerCodes.AETNA]: 1 },
  },
  {
    id: TileIds.INSURANCE_INSIGHT_FLU_SHOT,
    header: 'Free Flu Shots',
    description: () => `Get your annual flu shot at select locations`,
    rules: [TileRules.IS_INSURANCE_AETNA, TileRules.IS_NOT_CHILD],
    modalValue: AetnaModalValue.FLU_SHOT,
    sortOrder: { [InsurerCodes.AETNA]: 6 },
  },
  {
    id: TileIds.INSURANCE_INSIGHT_GYM_MEMBERSHIP,
    header: 'Work It Out',
    description: () => `Discount on select gym memberships`,
    rules: [TileRules.IS_INSURANCE_AETNA, TileRules.IS_NOT_CHILD],
    modalValue: AetnaModalValue.GYM_MEMBERSHIP,
    sortOrder: { [InsurerCodes.AETNA]: 2 },
  },
  {
    id: TileIds.INSURANCE_INSIGHT_CHIROPRACTOR,
    header: 'Get Aligned',
    description: () => `Discount on select chiropractors`,
    rules: [TileRules.IS_INSURANCE_AETNA, TileRules.IS_NOT_CHILD],
    modalValue: AetnaModalValue.CHIROPRACTOR,
    sortOrder: { [InsurerCodes.AETNA]: 9 },
  },
  {
    id: TileIds.INSURANCE_INSIGHT_ACUPUNCTURE,
    header: 'Stick It To Me',
    description: () => `Discounts on select acupuncturists`,
    rules: [TileRules.IS_INSURANCE_AETNA, TileRules.IS_NOT_CHILD],
    modalValue: AetnaModalValue.ACUPUNCTURE,
    sortOrder: { [InsurerCodes.AETNA]: 12 },
  },
  {
    id: TileIds.INSURANCE_INSIGHT_APPAREL,
    header: 'Get The Gear',
    description: () => `Discounts on select fitness apparel & shoes`,
    rules: [TileRules.IS_INSURANCE_AETNA, TileRules.IS_NOT_CHILD],
    modalValue: AetnaModalValue.APPAREL,
    sortOrder: { [InsurerCodes.AETNA]: 11 },
  },
  {
    id: TileIds.INSURANCE_INSIGHT_THERAPEUTIC_MASSAGE,
    header: 'Loosen Up',
    description: () => `Discounts on select massage therapists`,
    rules: [TileRules.IS_INSURANCE_AETNA, TileRules.IS_NOT_CHILD],
    modalValue: AetnaModalValue.THERAPEUTIC_MASSAGE,
    sortOrder: { [InsurerCodes.AETNA]: 4 },
  },
  {
    id: TileIds.INSURANCE_INSIGHT_LASIK,
    header: 'See Things Clearly',
    description: () => `Up to 15% off LASIK booked through US Laser Network`,
    rules: [TileRules.IS_INSURANCE_AETNA, TileRules.IS_NOT_CHILD],
    modalValue: AetnaModalValue.LASIK,
    sortOrder: { [InsurerCodes.AETNA]: 8 },
  },
];
